export default __webpack_public_path__ + "static/media/icon-info.a8e23c0e.svg";